import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { LinksService } from '../../services/links/links.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { Recording } from '@sc/types';
import { GeneralToastComponent } from '../../toasts/general-toast/general-toast.component';
import { SessionsService } from '../../services/sessions/sessions.service';

@Component({
  selector: 'sc-download-link-menu',
  templateUrl: './download-link-menu.component.html',
  styleUrls: ['./download-link-menu.component.scss'],
})
export class DownloadLinkMenuComponent implements OnInit, OnDestroy {
  @Input() recording: Recording;
  @Input() event: any;
  studioSession$ = this.sessionsService.studioSession$;
  mp4DownloadLink: string;
  webmDownloadLink: string;
  wavDownloadLink: string;
  mp3DownloadLink: string;

  subs: Array<Subscription> = [];

  constructor(
    private popoverController: PopoverController,
    private toastrService: ToastrService,
    private linkService: LinksService,
    private analyticsService: AnalyticsService,
    private sessionsService: SessionsService
  ) {}

  ngOnInit() {
    this.setupDownloadLinks();
  }

  setupDownloadLinks() {
    if (this.recording.mp4) {
      this.linkService
        .getShortLink({
          url: this.recording.mp4,
          title: `${this.recording.fileName}.mp4`,
          description: `🎥✨🎥 Recorded on SquadCast.fm`,
        })
        .then((response: any) => {
          this.mp4DownloadLink = JSON.parse(response).shortLink;
        })
        .catch((error) => {
          this.mp4DownloadLink = this.recording.mp4;
        });
    }

    if (this.recording.webm) {
      this.linkService
        .getShortLink({
          url: this.recording.webm,
          title: `${this.recording.fileName}.webm`,
          description: `🎥✨🎥 Recorded on SquadCast.fm`,
        })
        .then((response: any) => {
          this.webmDownloadLink = JSON.parse(response).shortLink;
        })
        .catch((error) => {
          this.webmDownloadLink = this.recording.webm;
        });
    }

    if (this.recording.wav) {
      this.linkService
        .getShortLink({
          url: this.recording.wav,
          title: `${this.recording.fileName}.wav`,
          description: `🎙️✨🎙️ Recorded on SquadCast.fm`,
        })
        .then((response: any) => {
          this.wavDownloadLink = JSON.parse(response).shortLink;
        })
        .catch((error) => {
          this.wavDownloadLink = this.recording.wav;
        });
    }

    if (this.recording.mp3) {
      this.linkService
        .getShortLink({
          url: this.recording.mp3,
          title: `${this.recording.fileName}.mp3`,
          description: `🎙️✨🎙️ Recorded on SquadCast.fm`,
        })
        .then((response: any) => {
          this.mp3DownloadLink = JSON.parse(response).shortLink;
        })
        .catch((error) => {
          this.mp3DownloadLink = this.recording.mp3;
        });
    }
  }

  async copy(link: string) {
    try {
      await navigator.clipboard.writeText(link);

      this.toastrService.success(null, `Successfully copied Share Link`, {
        progressBar: true,
        progressAnimation: 'decreasing',
        closeButton: true,
        tapToDismiss: false,
        timeOut: 5 * 1000,
        toastComponent: GeneralToastComponent,
      });

      this.close();
      await this.analyticsService.track('copied recording share link', { success: true });
    } catch (error) {
      this.toastrService.error(null, `Failed to copy Share Link`, {
        progressBar: true,
        progressAnimation: 'decreasing',
        closeButton: true,
        tapToDismiss: false,
        timeOut: 5 * 1000,
        toastComponent: GeneralToastComponent,
      });

      this.close();
      await this.analyticsService.track('copied recording share link', { success: false });
    }
  }

  async openRecordingMenu() {
    this.popoverController.dismiss();
  }

  close() {
    this.popoverController.dismiss();
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
